import React, {useEffect, useState} from "react"
import MetaTags from "react-meta-tags"
import {Container, Card, CardBody, Nav, NavItem, NavLink} from "reactstrap"
import classnames from "classnames"
import {withRouter} from "react-router"
import AddInstitutOrigin from "./AddInstitutOrigin"
import DataTableInstitutOrigin from "./DataTableInstitutOrigin";

const InstitutOrigin = props => {
    const [section, setSection] = useState(1)
    const [add, setAdd] = useState(0);
    const [cloture, setCloture] = useState(0);
    useEffect(async () => {
        var cloture_annee = JSON.parse(localStorage.getItem("cloture"));
        setCloture(cloture_annee)
        const userAuth = JSON.parse(localStorage.getItem('UserMenu'));
        const typeArticleSubMenu = userAuth.find(user =>
          user.sous_menu.some(subMenu => subMenu.sous_menu === "Institut d'origine")
        );
        setAdd(typeArticleSubMenu.sous_menu[0].add)
    }, [])
    const back = () => {
        setSection(1)
    }

    const renderBlock = section => {
        if (section === 1) {
            return <DataTableInstitutOrigin/>
        } else if (section === 2) {
            return <AddInstitutOrigin setSection={setSection} back={back}/>
        }
    }

    return (
      <React.Fragment>
          <div className="page-content">
              <MetaTags>
                  <title>Institut origin | Cresus </title>
              </MetaTags>
              <Container fluid>
                  <div>
                      <Nav tabs>
                          <NavItem>
                              <NavLink
                                style={{cursor: "pointer"}}
                                className={classnames({
                                    active: section === 1,
                                })}
                                onClick={() => {
                                    setSection(1)
                                }}
                              >
                                  {"Institut d'origine"}
                              </NavLink>
                          </NavItem>
                          {cloture != 1 ? (
                            add === 1 ? (
                              <NavItem>
                                  <NavLink
                                    style={{cursor: "pointer"}}
                                    className={classnames({
                                        active: section === 2,
                                    })}
                                    onClick={() => {
                                        setSection(2)
                                    }}
                                  >
                                      {"Ajouter institut d'origine"}
                                  </NavLink>
                              </NavItem>
                            ) : (null)
                          ) : (null)}
                      </Nav>
                      <Card>
                          <CardBody>{renderBlock(section)}</CardBody>
                      </Card>
                  </div>
              </Container>
          </div>
      </React.Fragment>
    )
}

export default withRouter(InstitutOrigin)
